import FileUploader from "devextreme-react/file-uploader";
import SelectBox from "devextreme-react/select-box";

import { Column } from "devextreme-react/data-grid";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { appInfo } from "../../../AppInfo";
import { ganMienGiamApi } from "../../../api/ganMienGiamApi";
import { Button } from "../../../components/buttons";
import { DefaultDataGrid } from "../../../components/data-grid";
import { AnimationPopup } from "../../../components/modal";
import { PlaceHolder } from "../../../components/place-holder";
import { Spinner } from "../../../components/spinners";
import { useCommonContext } from "../../../contexts/common";
import { showNotify } from "../../../helpers/toast";
import { PageBaseStatus } from "../../../models/pageBaseStatus";
import { useSelector } from "react-redux";
import { RootState } from "../../../state/reducers";
import { Box } from "@primer/react";
import { FormGroup } from "../../../components/form-group";
type GanMienGiamImportModalProps = {
    onClose: () => void,
    onSuccess: () => void,
    nam_hoc: string,
    animationOf: string
}
type GanMienGiamImportModalState = {
    status: PageBaseStatus,
    file_name: string,
    sheets: any[],
    sheet_index: number,
    data_source: any[],
    root_file_name: string

}
const initialState: GanMienGiamImportModalState = {
    status: PageBaseStatus.is_completed,
    data_source: [],
    file_name: "",
    sheet_index: -1,
    sheets: [],
    root_file_name: ''

}
export const GanMienGiamImportModal = (props: GanMienGiamImportModalProps) => {
    const [formData, SetFormData] = useState<GanMienGiamImportModalState>(initialState);
    const [isLoading, SetIsLoading] = useState<boolean>(false)
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [isLoadingSheets, SetIsLoadingSheets] = useState<boolean>(false)
    const { dm_coso_id } = useSelector((x: RootState) => x.common);

    const { createUUID } = useCommonContext();
    const onClose = useCallback(() => {
        window.animationHidePopup(props.animationOf || "")
        setTimeout(() => {
            props.onClose();
        }, 500);
    }, [props.animationOf])
    const grid = useRef<any>();
    const {
        status,
        file_name,
        sheets,
        sheet_index,
        data_source,
        root_file_name
    } = formData;
    //useEffect(() => {
    //    if (file_name) {
    //        reloadSheets();
    //    }
    //}, [file_name]);
    useEffect(() => {
        if (file_name !== "" && sheets.length > 0 && sheet_index >= 0) {
            reloadDatas();
        }
    }, [file_name, sheet_index, sheets]);


    const errr_code = useMemo(() => {
        const count = data_source.filter(x => !x.is_valid).length;
        if (count > 0) {
            return `Có ${count} dòng không hợp lệ, vui lòng kiểm tra lại dữ liệu`;
        }
        return "";
    }, [data_source]);

    const reloadSheets = async () => {
        SetIsLoadingSheets(true);
        const res = await ganMienGiamApi.getSheets(file_name);
        SetIsLoadingSheets(false)
        if (res.is_success) {
            SetFormData({ ...formData, sheets: res.data })
            if (res.data.length >= 1) {
                SetFormData({ ...formData, sheet_index: 0 })
            }
        }
    }
    const reloadDatas = async () => {
        SetIsLoading(true);
        const res = await ganMienGiamApi.readFiles({
            file_name: file_name, sheet_index: sheet_index,
            nam_hoc: props.nam_hoc, dm_coso_id: dm_coso_id,root_file_name: root_file_name
        });
        SetIsLoading(false)
        if (res.is_success) {
            SetFormData({ ...formData, data_source: res.data })
        } else {
            showNotify({ message: res.message || "Có lỗi, vui lòng kiểm tra lại sheet", type: "error" })
            SetFormData({ ...formData, data_source: [] })
        }

    }
    const handleSaveChanges = async () => {
        setIsSaving(true)
        const res = await ganMienGiamApi.import({
            file_name: file_name, sheet_index: sheet_index,
            nam_hoc: props.nam_hoc, dm_coso_id: dm_coso_id,root_file_name: root_file_name
        });
        setIsSaving(false)
        if (res.is_success) {
            showNotify({ message: "Import thành công", type: 'success' })
            props.onSuccess();
        } else {
            showNotify({ message: res.message || "Có lỗi", type: "error" })
        }
    };
    const onUploaded = (e: any) => {
        if (e && e.request && e.request.response) {
            const res = JSON.parse(e.request.response)
            if (res.is_success) {
                SetFormData({ ...formData, file_name: res.data.url, sheets: res.data.sheets, sheet_index: res.data.sheets.length > 0 ? 0 : -1 })
                //SetFormData({ ...formData, file_name: res.data[0].file_name_uploaded })
            }
        }
    }
    const columns: any = useMemo(() => {
        return [
            <Column key={createUUID()} dataField="id" caption="TT" width={80} />,
            <Column key={createUUID()} dataField="Nam_hoc" caption="Năm học" width={100} />,
            <Column key={createUUID()} dataField="Ma_hoc_sinh" caption="Mã HS" width={120} />,
            <Column key={createUUID()} dataField="Ma_mien_giam" caption="Mã miễn giảm" width={200} />,
            <Column key={createUUID()} dataField="So_lan_ap_dung" caption="Số lần áp dụng" width={100} />,
            <Column key={createUUID()} dataField="is_valid" caption="Hợp lệ" width={100} />,
            <Column key={createUUID()} dataField="error" caption="Mã lỗi" width={450} />
        ]
    }, []);
    return (

        <AnimationPopup
            title={`Import khoản miễn giảm năm học ${props.nam_hoc}`}
            animationOf={props.animationOf}
            onClose={onClose}
            width="90%"
        >
            <div className="pop-up-form">
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-inline" style={{ width: "100%" }}>
                            {file_name === "" &&
                                <div className="form-group" style={{ width: "33%" }}>
                                    <FileUploader
                                        multiple={false}
                                        accept={".xls,.xlsx"}
                                        uploadMode={"instantly"}
                                        uploadHeaders={{ Authorization: `Bearer ${localStorage.access_token}` }}
                                        uploadUrl={`${appInfo.baseApiURL}/sf_dexuatmiengiam/upload_file`}
                                        uploadMethod='POST'
                                        showFileList={false}
                                        onUploaded={onUploaded}
                                        labelText='hoặc kéo thả file tại đây để upload'
                                        selectButtonText='Chọn file'
                                    />

                                </div>
                            }
                            {file_name !== "" &&
                                <div className="form-group" style={{ width: "33%" }}>

                                    <FormGroup label='Chọn sheet' />
                                    <SelectBox
                                        dataSource={sheets}
                                        stylingMode="outlined"
                                        displayExpr={"name"}
                                        valueExpr={"idx"}
                                        value={sheet_index}
                                        width={200}
                                        readOnly={isLoadingSheets}
                                        placeholder="Chọn sheet"
                                        onValueChanged={(e) => {
                                            SetFormData({ ...formData, sheet_index: e.value })
                                        }}
                                    />
                                    {isLoadingSheets && <Spinner isBlack={true} />}
                                </div>
                            }

                            <div className="form-group" style={{ flexFlow: "row-reverse", width: "33%", color: "blue" }} >
                                <a style={{ cursor: "pointer", color: "#3c22ff" }} href="../../template/import_mien_giam.xlsx" target="_blank">Tải file mẫu</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        {errr_code && <p className="text-danger padding-top-1rem">{errr_code}</p>}
                    </div>
                    <div className="col-md-12 padding-top-1rem" style={{ width: "100%" }}>
                        {isLoading && <PlaceHolder line_number={20} />}
                        {!isLoading &&
                            <DefaultDataGrid
                                columns={columns}
                                dataSource={data_source}
                                gridRef={grid}
                                keyExpr="id"
                                height={window.innerHeight - 350}
                            />
                        }
                    </div>
                </div>
            </div>
            <div className="pop-up-actions">
                <Button type="normal" icon="fa fa-times" text="Đóng" onClick={onClose}></Button>{' '}
                <Button type="normal" icon="fas fa-check-square" text="Import" onClick={handleSaveChanges} isLoading={isSaving} isDisabled={errr_code !== ""} />
            </div>
        </AnimationPopup>
    )
}